/**
 * RequestAccessList Messages
 *
 * This contains all the text for the RequestAccessList component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.admin.requestAccess.list';

export default defineMessages({
  listColumnHeaderWorkspace: {
    id: `${scope}.columns.headers.workspace`,
    defaultMessage: 'Workspace',
  },
  listColumnHeaderManager: {
    id: `${scope}.columns.headers.manager`,
    defaultMessage: 'Manager',
  },
  listColumnHeaderReason: {
    id: `${scope}.columns.headers.reason`,
    defaultMessage: 'Reason',
  },
  listColumnHeaderDate: {
    id: `${scope}.columns.headers.date`,
    defaultMessage: 'Date',
  },
  listColumnHeaderEmail: {
    id: `${scope}.columns.headers.email`,
    defaultMessage: 'Email',
  },
  listColumnHeaderAction: {
    id: `${scope}.columns.headers.action`,
    defaultMessage: 'Action',
  },
  listColumnHeaderStatus: {
    id: `${scope}.columns.headers.status`,
    defaultMessage: 'Status',
  },
  statusComplete: {
    id: `${scope}.status.complete`,
    defaultMessage: 'Completed',
  },
  statusDenied: {
    id: `${scope}.status.denied`,
    defaultMessage: 'Denied',
  },
  actionApprove: {
    id: `${scope}.action.approve`,
    defaultMessage: 'Approve',
  },
  actionDeny: {
    id: `${scope}.action.deny`,
    defaultMessage: 'Deny',
  },
});
